import { useAuth0 } from '@auth0/auth0-react';

import './styles.scss';

export default function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  return <div className='loginLink' onClick={() => loginWithRedirect()}>Log In</div>;
}